function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var UruguayFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_648",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_648)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#F7FCFF"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_648",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_648)",
      children: [/*#__PURE__*/_jsx("rect", {
        y: "6",
        width: "24",
        height: "1.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("rect", {
        y: "9",
        width: "24",
        height: "1.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("rect", {
        y: "12",
        width: "24",
        height: "1.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("rect", {
        y: "15",
        width: "24",
        height: "1.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("rect", {
        y: "18",
        width: "24",
        height: "1.5",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("rect", {
        y: "3",
        width: "12",
        height: "10.5",
        fill: "#F7FCFF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.92066 11.2779C6.92066 11.2779 6.15424 12.8669 5.48063 13.1927C5.77138 12.4639 5.87841 10.9768 5.87841 10.9768C5.87841 10.9768 4.12947 11.6702 3.51561 11.5439C4.25375 11.0281 5.27831 10.0727 5.27831 10.0727C5.27831 10.0727 3.01464 9.33264 3.07018 9.01768C4.09204 9.20098 5.49732 9.00116 5.49732 9.00116C5.49732 9.00116 3.90928 7.09673 4.07032 6.95511C4.31239 7.1904 6.21555 8.18454 6.21555 8.18454C6.21555 8.18454 6.35363 6.49014 6.76321 5.91886C6.81234 6.32212 7.38721 8.14789 7.38721 8.14789C7.38721 8.14789 8.54287 6.99156 9.1843 6.99156C8.90256 7.34089 8.23544 8.87534 8.23544 8.87534C8.23544 8.87534 9.89804 8.84918 10.5301 9.16036C9.76442 9.26926 8.423 9.9427 8.423 9.9427C8.423 9.9427 10.1701 11.268 10.0108 11.5439C9.07278 11.085 7.98833 10.9313 7.98833 10.9313C7.98833 10.9313 8.28808 12.7756 8.04578 13.1927C7.80947 12.5787 6.92066 11.2779 6.92066 11.2779Z",
        fill: "#FFD018",
        stroke: "#F19900",
        strokeOpacity: "0.98",
        strokeWidth: "0.25"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.82019 10.4189C7.2344 10.4189 7.57019 10.0831 7.57019 9.66886C7.57019 9.25465 7.2344 8.91886 6.82019 8.91886C6.40598 8.91886 6.07019 9.25465 6.07019 9.66886C6.07019 10.0831 6.40598 10.4189 6.82019 10.4189Z",
        fill: "#FFD018",
        stroke: "#F19900",
        strokeOpacity: "0.98",
        strokeWidth: "0.25"
      })]
    })]
  })]
}));
//# sourceMappingURL=Uruguay.js.map